import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6 9h44v46H6V9z",
      stroke: "#1e3951",
      "stroke-width": "2",
      fill: "#fff",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8 12h40v41H8V12z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#86bc4d"
    }, null, -1),
    _createElementVNode("path", {
      d: "M37.5 12.5v40M26 21h22m-22 8h22m-22 8h22m-22 8h22M27.5 12.5v40M17 21h20m-20 8h20m-20 8h20m-20 8h20M17.5 12.5v40M8 21h20M8 29h20M8 37h20M8 45h20",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "none"
    }, null, -1),
    _createElementVNode("path", {
      d: "M58.437 48.28h-.712c-.644 2.224-1.433 3.733-2.39 4.526-.954.805-3.002.56-4.913.56H47.55l6.786-10.258-7.035-10.38h7.223c1.677 0 .923.147 1.812 1.144.89 1.01.288-.14.51 2.212l1.733-.088-.17-8.996H38l.87.716 8.59 15.033-9.194 15.93L38 59h20.578L60 48.455l-1.563-.175z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#55acba"
    }, null, -1)
  ])))
}
export default { render: render }